import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js';
import { useFormikContext } from 'formik';
import styled from 'styled-components';

import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';
import { Label } from '@hivebrite/design-system/Label';

const SplitedCardFields = () => {
  const { setFieldError, errors } = useFormikContext();

  const onChange = (element) => {
    setFieldError(element.elementType, element.error?.message);
  };

  return (
    <Wrapper>
      <Box flexDirection="column" mb={3} data-testid="card-number">
        <Label id="stripe-card-number" required>
          {s__('Stripe|Card number')}
        </Label>
        <CardNumberElement
          options={{
            showIcon: true,
          }}
          id="stripe-card-number"
          onChange={onChange}
        />

        {errors.cardNumber && (
          <AdditionalInformation id="stripe-card-number">
            {errors.cardNumber}
          </AdditionalInformation>
        )}
      </Box>
      <Box flexDirection="column" with="100%" mb={3} data-testid="card-expiry">
        <Label id="stripe-card-expiry" required>
          {s__('Stripe|Expiration date')}
        </Label>
        <CardExpiryElement id="stripe-card-expiry" onChange={onChange} />
        {errors.cardExpiry && (
          <AdditionalInformation id="stripe-card-expiry">
            {errors.cardExpiry}
          </AdditionalInformation>
        )}
      </Box>
      <Box flexDirection="column" with="100%" mb={3} data-testid="card-cvc">
        <Label id="stripe-card-cvc" required>
          {s__('Stripe|CVC')}
        </Label>
        <CardCvcElement id="stripe-card-cvc" onChange={onChange} />
        {errors.cardCvc && (
          <AdditionalInformation id="stripe-card-cvc">
            {errors.cardCvc}
          </AdditionalInformation>
        )}
      </Box>
    </Wrapper>
  );
};

export default SplitedCardFields;

const Wrapper = styled(Box)`
  flex-direction: column;
  row-gap: 12px;

  .StripeElement {
    box-sizing: border-box;

    height: 40px;

    padding: 10px 12px;

    border: 1px solid transparent;
    border-radius: 4px;
    background-color: white;

    box-shadow: rgb(115 115 115) 0 0 0 1px inset !important;
  }

  .StripeElement--focus {
    box-shadow: rgb(115 115 115) 0 0 0 1px inset !important;
  }

  .StripeElement--invalid {
    box-shadow: rgb(177 14 11) 0 0 0 1px inset !important;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }
`;
